<template>
  <el-dialog
    :title="isEdit ? '编辑材料' : '新增材料'"
    :visible.sync="visible"
    width="560px"
    append-to-body
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="材料名称" prop="materialName">
        <el-input v-model="form.materialName" placeholder="请输入材料名称" maxlength="200" show-word-limit />
      </el-form-item>
      <el-form-item label="材料类型" prop="materialType">
        <dict-select
          :key="materialTypeDictSelectKey"
          v-model="form.materialType"
          :dict-type="DICT_TYPE.MATERIAL_TYPE"
          placeholder="请选择材料类型"
          style="width: 100%"
        />
        <div class="dict-empty-hint">
          如需维护材料类型，可前往
          <el-button  type="text" class="dict-empty-hint-link" @click="goDictManage(DICT_TYPE.MATERIAL_TYPE)">字段管理</el-button>
          菜单中新增或修改。
        </div>
      </el-form-item>
      <el-form-item label="计量单位" prop="unit">
        <dict-select
          :key="materialUnitDictSelectKey"
          v-model="form.unit"
          :dict-type="DICT_TYPE.MATERIAL_UNIT"
          placeholder="请选择计量单位"
          style="width: 100%"
        />
        <div class="dict-empty-hint">
          如需维护计量单位，可前往
          <el-button type="text" class="dict-empty-hint-link" @click="goDictManage(DICT_TYPE.MATERIAL_UNIT)">字段管理</el-button>
          菜单中新增或修改。
        </div>
      </el-form-item>
      <el-form-item v-if="!isEdit" label="初始入库数" prop="initialInCount">
        <el-input-number
          v-model="form.initialInCount"
          :min="0"
          :precision="0"
          placeholder="请输入初始入库数量(可选)"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item prop="warningThreshold">
        <template slot="label">
          <span class="form-label-with-tip">
            <span>预警阈值</span>
            <el-tooltip content="当剩余数量低于预警值时变为库存不足状态" placement="top">
              <i class="el-icon-question warning-threshold-tip-icon" />
            </el-tooltip>
          </span>
        </template>
        <el-input-number
          v-model="form.warningThreshold"
          :min="0"
          :precision="0"
          placeholder="请输入预警阈值(可选)"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item v-if="!isEdit" label="材料来源">
        <el-input v-model="form.supplier" placeholder="请输入材料来源" maxlength="200" />
      </el-form-item>
      <el-form-item label="存放位置">
        <el-input v-model="form.storageLocation" placeholder="请输入存放位置" maxlength="200" />
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="备注信息" maxlength="500" show-word-limit />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" :loading="loading" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
// 服务
import { materialService } from './material.service';
// 工具函数
import { DICT_TYPE } from '@/features/components/dict/dictTypeKeys';

export default {
  name: 'MaterialDialog',
  data () {
    return {
      DICT_TYPE,
      materialTypeDictSelectKey: 0,
      materialUnitDictSelectKey: 0,
      visible: false,
      loading: false,
      isEdit: false,
      form: {
        uuid: null,
        materialName: '',
        materialType: '',
        unit: '',
        warningThreshold: 0,
        storageLocation: '',
        initialInCount: 0,
        supplier: '',
        remark: ''
      },
      rules: {
        materialName: [{ required: true, message: '请输入材料名称', trigger: 'blur' }],
        initialInCount: [{ required: true, message: '请输入初始入库数量', trigger: 'blur' }]
      }
    };
  },
  methods: {
    goDictManage (dictType) {
      this.visible = false;
      const query = dictType ? { dictType } : {};
      this.$nextTick(() => {
        this.openNavTab({ name: 'dictList', query });
      });
    },
    open (row) {
      this.materialTypeDictSelectKey += 1;
      this.materialUnitDictSelectKey += 1;
      this.visible = true;
      this.isEdit = !!row;
      if (row) {
        this.form = {
          uuid: row.uuid,
          materialName: row.materialName,
          materialType: row.materialType || '',
          unit: row.unit || '',
          warningThreshold: row.warningThreshold || 0,
          initialInCount: row.initialInCount || 0,
          supplier: row.supplier || '',
          storageLocation: row.storageLocation || '',
          remark: row.remark || ''
        };
      } else {
        this.resetForm();
      }
    },
    resetForm () {
      this.form = { uuid: null, materialName: '', materialType: '', unit: '', warningThreshold: 0, initialInCount: 0, supplier: '', storageLocation: '', remark: '' };
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
    },
    handleClose () {
      this.visible = false;
      this.resetForm();
    },
    handleSubmit () {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const request = this.isEdit
          ? materialService.updateMaterial(this.form)
          : materialService.saveMaterial(this.form);

        request.then(() => {
          this.$message.success(this.isEdit ? '编辑成功' : '新增成功');
          this.handleClose();
          this.$emit('success');
        }).finally(() => {
          this.loading = false;
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.form-label-with-tip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.warning-threshold-tip-icon {
  color: #909399;
  font-size: 14px;
  cursor: help;
  font-weight: normal;
}

.dict-empty-hint {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}

.dict-empty-hint-link {
  padding: 0;
  vertical-align: baseline;
  font-size: 12px;
}
</style>
